const integrationsDictPT = {
  // Integrações
  integrations: "Integrações",
  integrationsDescription:
    "Acesse ferramentas e aplicativos integrados prontos para suas atividades na Extraconomy.",
  configure: "Configurar",
  integrationData: "Dados de integração",

  // WhatsApp
  whatsappIntegrationDescription: "Gerencie o número de contato visível em sua loja.",
  phoneNumber1: "Número de Telefone",
  enterYourPhoneNumber: "Digite seu número de telefone",
  confirmationCode: "Código de Confirmação",
  enterReceivedCode: "Digite o código recebido",
  goBackAndResendCode: "Voltar e reenviar código",

  // Mensagens
  attention: "Atenção",
  success: "Sucesso",
  error: "Erro",
  codeSent: "Código Enviado",
  codeSentTo: "Código enviado para",

  // Validações
  pleaseProvidePhoneNumber: "Por favor, informe o número de telefone",
  pleaseProvideConfirmationCode: "Por favor, informe o código de confirmação",

  // Sucesso
  confirmationCodeSentToWhatsApp: "Código de confirmação enviado para o WhatsApp",
  whatsappConfiguredSuccessfully: "WhatsApp configurado com sucesso!",
  configurationSavedSuccessfully: "Configuração salva com sucesso",

  // Erros
  errorConnectingToServer: "Erro ao conectar com o servidor",
  invalidConfirmationCode: "Código de confirmação inválido",
  errorConfirmingCode: "Erro ao confirmar código",
};

export default integrationsDictPT;
